export default __webpack_public_path__ + "static/media/img1.7da2ae4c.PNG";